export default {
  init() {
    // JavaScript to be fired on all pages

    $('#mobile-menu-toggle').on('click', function(){
      if ($('#mobile-menu').hasClass('active')) {
        $(this).find('span').html('Menu');
        $('#mobile-menu').removeClass('active');
        $('#mobile-menu').fadeOut();
      } else {
        $(this).find('span').html('Sluiten');
        $('#mobile-menu').addClass('active');
        $('#mobile-menu').fadeIn();
      }
    });

    // $('#mobile-menu .menu-item a').on('click', function(){
      // $('#mobile-menu-toggle').find('span').html('Menu');
      // $('#mobile-menu').removeClass('active');
      // $('#mobile-menu').fadeOut();
    // });

    // Initiate Slick Sliders
    $('.news-slider').each(function() {
      var target = $(this).data('arrows');
      var pagination = $(this).data('pagination');
      const total = $(this).find('.slide').length;

      $(pagination).html('1 van ' + total);

      var options = {
        arrows: true,
        dots: false,
        adaptiveHeight: true,
      };

      if (target !== '' && target !== undefined) {
        options.appendArrows = $(target);
      }
  
      $(this).slick(options);

      $(this).on('afterChange', function(slick, currentSlide) {
        $(pagination).html((currentSlide.currentSlide + 1) + ' van ' + currentSlide.slideCount);
      });
    });


    $('.post-link').on('click', function(e){
      e.preventDefault();

      const id = $(this).data('id');

      var data = {
        'action': 'get_news_post',
        'id': id,
      }

      $.post(
        window.my_ajax_object.ajax_url,
        data,
        function (intel) {
          const payload = JSON.parse(intel);
          
          $('#overlay-news_title').html(payload.title);
          $('#overlay-news_date').html(payload.date);
          $('#overlay-news_content').html(payload.content);

          $('#overlay-news-post').fadeIn();
        }
      );

    });

    $('.overlay-close').on('click', function(){
      var target = $(this).data('target');

      $(target).fadeOut();
    });

    $('.overlay-mask').on('click', function(e){
      // console.log('e', e.srcElement.className, e.srcElement.className.indexOf('overlay-body'));
      
      if (e.srcElement.className.indexOf('overlay-body') >= 0) {
        var target = $(this).data('target');
        $(target).fadeOut();
      }
    });

    // Collapse ////////////////////////////////////////////////////////
    // Initialized collapse elements
    setTimeout(() => {
      $('.collapse').each(function () {
        var elm = $(this);
        var h = elm[0].scrollHeight;
  
        elm[0].style.height = h + 'px';
      });
    }, 500);

    // When collapse toggle is clicked
    $('body').on('click', '.collapse-toggle', function () {
      var toggle = $(this);
      var group = $(this).data('group');
      var target = $($(this).data('target'));
      var limit = $(this).data('limit');

      if (limit === 'any') {
        target.toggleClass('close');
        toggle.toggleClass('active');
      } else {
        if (toggle.hasClass('active')) {
          toggle.removeClass('active');
          target.addClass('close');
        } else {
          $(group + '.collapse-toggle').removeClass('active');
          toggle.addClass('active');
          $(group + '.collapse').addClass('close');
          target.removeClass('close');
        }
      }

      var slickTarget = $(this).data('slick');
      
      if (slickTarget !== undefined) {
        var slideIndex = $(this).data('goto');

        $(slickTarget).slick('slickGoTo', (parseInt(slideIndex)));
      }
    });

    // When window resize update collapse element height
    $(window).resize(function () {
      $('.collapse').each(function () {
        var elm = $(this);

        elm[0].style.height = 'auto';

        var h = elm[0].scrollHeight;

        elm[0].style.height = h + 'px';
      });
    });
    // Collapse //////////////////////////////////////////////////////// END

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    $(function() {
      $('a[href*=#]:not([href=#])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

          var ww = $(window).width();
          var offset = $('.header-mobile').outerHeight(true);
          
          if (ww >= 768) {
            offset = $('.header-desktop').outerHeight(true);
          }

          if (target.length) {
            $('html,body').animate({
              scrollTop: target.offset().top - offset,
            }, 1000);
            return false;
          }
        }
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js